import React from 'react';
import './App.css';
import { Modal, Button, Form } from 'react-bootstrap';


class ShareLinkItem extends React.Component {

	constructor(props, context) {
		super(props, context);

    	this.formRef = React.createRef();

		this.handleClose = this.handleClose.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleShow = this.handleShow.bind(this);

		this.state = {
		  	validated:false,
		  	email:'',
		  	linkType:'Image',
		  	emailMessage:'',
		};
	}


	handleShow(){ this.setState({validated:false,}); }

	handleClose(){
		this.props.onClose();
	}

	handleMailChange(event){ this.setState({email:event.target.value}); }
	handleTypeChange(event){ this.setState({linkType:event.target.value}); }
	handleMessageChange(event){ this.setState({emailMessage:event.target.value}); }

	handleSubmit(event) {
		const form = event.currentTarget;
	    this.setState({ validated: true });
	    event.preventDefault();
	    event.stopPropagation();
	    if (form.checkValidity() === true) {
			this.props.onShare(
				{
					email:this.state.email,
					linkType:this.state.linkType,
					emailMessage:this.state.emailMessage
				});  
		}
	}

	render(){
		const { validated } = this.state;
		return (
			<Modal show={this.props.shouldShow} onHide={this.handleClose} onShow={this.handleShow}>
          		<Modal.Header closeButton>
            		<Modal.Title>Share content</Modal.Title>
          		</Modal.Header>
          		<Modal.Body>
					<Form noValidate validated={validated} onSubmit={e => this.handleSubmit(e)} >
		          		<Form.Group controlId="shareForm.email" >
							<Form.Label>Email</Form.Label>
							<Form.Control onChange={(e)=>this.handleMailChange(e)} required type="email" multiple placeholder="name@example.com, name2@example.com,..." />
						</Form.Group>
		       			{/* disabled due to the fact that i'll send an email with a link
		          		<Form.Group controlId="shareForm.shareType">
							<Form.Label>Content to share</Form.Label>
							<Form.Control value={this.state.linkType} as="select" onChange={(e)=>this.handleTypeChange(e)}>
							  <option>Image</option>
							  <option>Link</option>
							</Form.Control>
						</Form.Group>
						*/}
						<Form.Group controlId="shareForm.message">
							<Form.Label>Email notes</Form.Label>
							<Form.Control onChange={(e)=>this.handleMessageChange(e)}  as="textarea" placeholder="Something to add to your email?" />
						</Form.Group>

						<Form.Group>
			        		<Button type="submit">Share</Button>
						</Form.Group>
			      </Form>
       			</Modal.Body>
        	</Modal>
          	);
	}
}
export default ShareLinkItem;